import React from 'react';
import styles from './Spinner.module.css';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'medium', color, className }) => {
  const spinnerStyle = color ? ({ '--spinner-color': color } as React.CSSProperties) : {};

  return (
    <div className={`${styles.spinner} ${styles[size]} ${className || ''}`} style={spinnerStyle} role="status" aria-label="Loading">
      <div className={styles.spinnerInner}></div>
    </div>
  );
};
